import { createValidationMessage } from '../../../../validation/create-validation-message'

import { createUIDefinition } from '../default-task-definition'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'
import { WAITING_FOR_BOTH_PAYMENTS, PAYMENT_REMINDER_SENT } from './state-name'


export default createUIDefinition({
    taskName: null,
    stateNameList: [
        WAITING_FOR_BOTH_PAYMENTS,
        PAYMENT_REMINDER_SENT,
    ],
    widgetList: [
        {
            component: processUI.TREATMENT_PAYMENT_WIDGET,
        },
    ],
    overwriteWidget: true,
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (processInstance, eventName, context) => {
        if (eventName !== 'payments_received') {
            return null
        }

        const messageList = []

        const physicianPaymentReceived = context.physicianPaymentReceived
        const sunshinePaymentReceived = context.sunshinePaymentReceived

        // // make sure at least one is true
        if (eventName === 'payments_received' && (!physicianPaymentReceived || !sunshinePaymentReceived)) {
            messageList.push(createValidationMessage('Both payments need to be received.', 'checkTreatmentPayments.payments_received'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/confirm-treatment-payments.js